export default __webpack_public_path__ + "static/media/privacyplan-performance.fdef738a.png";